/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Link, Flex, Image, useMultiStyleConfig} from '@chakra-ui/react'

const ApplicationIcons = ({icons}) => {
    const styles = useMultiStyleConfig('Footer')

    return (
        <Flex {...styles.appIcons}>
            {icons?.length > 0 &&
                icons.map(({icon, link}) => (
                    <Link key={link?.title} href={link?.href} isExternal>
                        <Image loading="lazy" src={icon?.url} alt={icon?.description} />
                    </Link>
                ))}
        </Flex>
    )
}

ApplicationIcons.displayName = 'ApplicationIcons'

ApplicationIcons.propTypes = {
    icons: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.shape({url: PropTypes.string}),
            link: PropTypes.shape({title: PropTypes.string, href: PropTypes.string}),
        }),
    ),
}

export default ApplicationIcons
